import React, { useContext, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { UserContext } from "../../Context/UserContextAPI";
import useQueryFetch from "../../hooks/useQueryFetch";
import Loading2 from "../../utils/Loader/Loading2";
import request from "../../utils/request";
import MedicalPathology from "../Investigation/Report/MedicalPathology/MedicalPathology";
import MedicalPhysical from "../Investigation/Report/MedicalPhysical/MedicalPhysical";
import MedicalXray from "./../Investigation/Report/MedicalXray/MedicalXray";
import { useAllSaveTests } from "./useAllTestSave";
import UserTableInReport from "../../components/Users/UserTableInReports";

const EntryPage = () => {
  const { userId } = useParams();

  // api call for user detail
  const { data: userDetailData, isLoading } = useQueryFetch(
    ["user", userId],
    () => request.getOne("user-details/test", userId)
  );
  const userDetail = userDetailData?.userDetail;

  const physicalEntryRef = useRef();
  const pathologyEntryRef = useRef();
  const xrayEntryRef = useRef();

  const { accessPerm, settingsData } = useContext(UserContext);

  const { mutate: saveTests, isPending } = useAllSaveTests(
    physicalEntryRef,
    pathologyEntryRef,
    xrayEntryRef
  );

  const callNormalValue = () => {
    if (physicalEntryRef.current) {
      physicalEntryRef.current.handleNormalValue();
    }
    if (pathologyEntryRef.current) {
      pathologyEntryRef.current.handleNormalValue();
    }
    if (xrayEntryRef.current) {
      xrayEntryRef.current.handleNormalValue();
    }
  };

  // const callSaveValue = async () => {
  //   try {
  //     const physicalPromise = physicalEntryRef.current
  //       ? physicalEntryRef.current.savePhysicalReport()
  //       : Promise.resolve();

  //     const pathologyPromise = pathologyEntryRef.current
  //       ? pathologyEntryRef.current.savePathologyReport()
  //       : Promise.resolve();

  //     const xrayPromise = xrayEntryRef.current
  //       ? xrayEntryRef.current.saveRadiologyReport()
  //       : Promise.resolve();

  //     await Promise.all([physicalPromise, pathologyPromise, xrayPromise]);
  //     toast.success("Tests saved successfully!");
  //   } catch (error) {
  //     toast.error("Failed to save tests.");
  //     console.error(error);
  //   }
  // };

  const collection = userDetail?.user?.user_collections?.map(
    (collection) => collection.investigation_category?.investigation_group_id
  );
  const uniqueCollection = [...new Set(collection)];
  return (
    <>
      {isLoading ? (
        <Loading2 />
      ) : (
        <>
          <div className="card px-3 pt-1 medical-report">
            <p className="mb-0 fs-4 text-dark">
              Medical Report for {userDetail?.user?.f_name}{" "}
              {userDetail?.user?.l_name} [{userDetail?.user?.reg_prefix || ""}
              {userDetail?.user?.registration_no}]
            </p>

            <div className="row justify-content-center h-100">
              {userDetail && (
                <UserTableInReport
                  user={{
                    ...userDetail?.user,
                    userDetail: userDetail,
                  }}
                />
              )}
            </div>

            {uniqueCollection?.includes(3) && (
              <MedicalPhysical
                fromEntryPage
                physicalEntryRef={physicalEntryRef}
              />
            )}

            {uniqueCollection?.includes(2) && (
              <MedicalXray fromEntryPage xrayEntryRef={xrayEntryRef} />
            )}

            {uniqueCollection?.includes(1) && (
              <MedicalPathology
                fromEntryPage
                pathologyEntryRef={pathologyEntryRef}
              />
            )}
          </div>
          <div className="row px-4 mb-3">
            <div className="row mt-3">
              <div className="col-6">
                <div className="d-flex gap-2">
                  {userDetailData?.nextPage &&
                    settingsData?.next_prev_button === 1 && (
                      <Link
                        to={`/dashboard/entry/${userDetailData?.nextPage}`}
                        className="btn btn-primary"
                      >
                        Previous
                      </Link>
                    )}
                  {userDetailData?.previousPage &&
                    settingsData?.next_prev_button === 1 && (
                      <Link
                        to={`/dashboard/entry/${userDetailData?.previousPage}`}
                        className="btn btn-primary"
                      >
                        Next
                      </Link>
                    )}
                </div>
              </div>
              <div className="col-6">
                <div className="d-flex gap-2 justify-content-end">
                  {accessPerm(33, 22) && (
                    <button
                      className="btn btn-primary"
                      onClick={callNormalValue}
                    >
                      Set Normal
                    </button>
                  )}
                  <button
                    className="btn btn-success px-2"
                    onClick={saveTests}
                    disabled={isPending}
                  >
                    {isPending ? "Saving..." : "Save Results"}
                  </button>

                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      window.close();
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EntryPage;
